import React, { useEffect } from "react";

//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
import { DocumentFormTypes } from "models/formTypes";
import { FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import { EntityCardContent, FileViewerContainer } from "components/common";
import ClassifiedReceiptFooter from "components/receipt/classifiedReceipt/classifiedReceiptFooter";
//#endregion
//#region services
import { useDocumentDraftService } from "serviceHooks";
//#endregion
import ClassifiedReceiptTopCardContent from "./classifiedReceipt/classifiedReceiptTopCardContent";
import ClassifiedReceiptMainSection from "./classifiedReceipt/classifiedReceiptMainSection";

const ClassifiedReceiptTodo: React.FC<TodoCardProps> = (props) => {
  const documentDraftService = useDocumentDraftService();
  const classifiedReceipt = props.item.classifiedReceipt;
  const formRef = React.useRef<FormHandles>(null);

  const [images, setImages] = React.useState<ImageMeta[]>([]);

  useEffect(() => {
    if (classifiedReceipt) {
      const images =
        classifiedReceipt.images?.map<ImageMeta>((meta) => ({
          id: meta.id,
          contentType: meta.contentType,
          fileName: meta.fileName,
          numberOfPages: 1,
        })) ?? [];
      setImages(images);
      classifiedReceipt.images?.forEach((image) => {
        documentDraftService.getAttachmentData(classifiedReceipt.id, image.id).then((res) => {
          setImages((prevImages) => {
            const newImages = prevImages.map((p) => ({ ...p }));
            const imagesToUpdate = newImages.find((a) => a.id === image.id);
            if (imagesToUpdate) {
              imagesToUpdate.data = res;
            }
            return newImages;
          });

          if (formRef.current && formRef.current.getValues && formRef.current.setFieldValue) {
            const values: DocumentFormTypes.Create = formRef.current.getValues();
            const newFiles = [...(values.filesToUpload ?? [])];
            const file = newFiles.find((x) => x.id === image.id);
            if (file) {
              file.data = res;
              formRef.current.setFieldValue(FormFieldConstants.Document.Create.FilesToUpload, newFiles);
            }
          }
        });
      });
    }
  }, [classifiedReceipt?.images]);

  return (
    <EntityCardContent
      topTodoCard={<ClassifiedReceiptTopCardContent classifiedReceipt={classifiedReceipt!} formRef={formRef} />}
      todoMainSection={
        classifiedReceipt && <ClassifiedReceiptMainSection classifiedReceipt={classifiedReceipt} formRef={formRef} />
      }
      infoViewer={
        images.length ? (
          <FileViewerContainer
            key={classifiedReceipt?.id}
            meta={images}
            parentId={classifiedReceipt?.id ?? 0}
            loading={classifiedReceipt === undefined}
          />
        ) : undefined
      }
      footer={
        <ClassifiedReceiptFooter
          classifiedReceipt={classifiedReceipt!}
          markAsDone={props.onActionSuccess}
          formRef={formRef}
        />
      }
    ></EntityCardContent>
  );
};

export default ClassifiedReceiptTodo;